import { Options } from '@contentful/rich-text-react-renderer'

import { renderNode } from './options'

export const OPTIONS: Options = {
  renderNode,
}
